var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOptionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.15,
    fill: "white",
    stroke: "#707070",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7753 8.84961C12.539 8.84961 11.5368 9.85183 11.5368 11.0881C11.5368 12.3244 12.539 13.3267 13.7753 13.3267C15.0116 13.3267 16.0138 12.3244 16.0138 11.0881C16.0138 9.85183 15.0116 8.84961 13.7753 8.84961Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3876 14.5205C10.1513 14.5205 9.14905 15.5227 9.14905 16.759V17.4684C9.14905 17.918 9.47491 18.3014 9.91866 18.3738C12.4729 18.7908 15.0778 18.7908 17.632 18.3738C18.0757 18.3014 18.4016 17.918 18.4016 17.4684V16.759C18.4016 15.5227 17.3994 14.5205 16.1631 14.5205H15.9596C15.8495 14.5205 15.74 14.5379 15.6353 14.5721L15.1187 14.7408C14.2458 15.0259 13.3049 15.0259 12.432 14.7408L11.9153 14.5721C11.8106 14.5379 11.7012 14.5205 11.591 14.5205H11.3876Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionIcon);
export default __webpack_public_path__ + "static/media/option-icon.a786742ca793f8d60906a17acfebc444.svg";
export { ForwardRef as ReactComponent };